import React from 'react';
import Organizer from '../../../models/inkind-organizers/Organizer';
import { OwnerListItem, OrganizerListItem, InviteeListItem } from './OrganizerListItem';

export interface IOrganizersListProps {
  pageOwner: Organizer;
  pageOrganizers: Organizer[];
  pageInvitees: Organizer[];
  routeId: string;
  onRemoveOrganizer: () => void;
  onUpdateSettings: () => void;
}

export default function OrganizersList({
  pageOwner,
  pageOrganizers,
  pageInvitees,
  routeId,
  onRemoveOrganizer,
  onUpdateSettings,
}: React.PropsWithChildren<IOrganizersListProps>): JSX.Element {
  return (
    <div className="inkind-organizers-list">
      <section className="inkind-organizers-list-header">
        <div></div>
        <div>EDIT</div>
        <div>EMAIL</div>
        <div></div>
      </section>

      <OwnerListItem
        key={pageOwner.userId}
        onRemoveOrganizer={onRemoveOrganizer}
        onUpdateSettings={onUpdateSettings}
        organizer={pageOwner}
        className="owner-entry"
        routeId={routeId}
      ></OwnerListItem>

      {pageOrganizers &&
        pageOrganizers.map(organizer => (
          <OrganizerListItem
            key={organizer.userId}
            onRemoveOrganizer={onRemoveOrganizer}
            onUpdateSettings={onUpdateSettings}
            organizer={organizer}
            className="confirmed-entry"
            routeId={routeId}
          ></OrganizerListItem>
        ))}

      {pageInvitees &&
        pageInvitees.map(organizer => (
          <InviteeListItem
            key={organizer.userId}
            onRemoveOrganizer={onRemoveOrganizer}
            onUpdateSettings={onUpdateSettings}
            organizer={organizer}
            className="invite-entry"
            routeId={routeId}
          ></InviteeListItem>
        ))}
    </div>
  );
}
